import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
// import "./GuestTab.css";
// import StatCard from "../components/statCard/StatCard";
import TabSelector from "../../components/tabSelector/TabSelector";
import EventCard from "../../components/eventCard/EventCard";
import Header from "../../components/header/Header";
import {
  LockShieldIcon,
  CashIcon,
  NotificationBellIcon,
  UsersGroupIcon,
  CalendarIcon,
  PlusCircleIcon,
} from "../../helper/icon";
import StatCards from "../../components/statCard/StatCard";
import EventHeader from "../../components/eventHeader/EventHeader";
import { formatDateWithOrdinal } from "../../helper/utils";

const EventManagement = () => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [activeTab, setActiveTab] = useState("upcoming");
  const [guestFilter, setGuestFilter] = useState("all");
  const [currentDate, setCurrentDate] = useState(new Date());

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    const dateUpdateInterval = setInterval(() => {
      setCurrentDate(new Date());
    }, 60000);

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      clearInterval(dateUpdateInterval);
    };
  }, []);

  const handleTabChange = (tabId) => {
    console.log("Tab changed to:", tabId);
    // Your logic here
  };

  const handleEventClick = (eventId) => {
    navigate(`/eventManagement/${eventId}`);
  };

  const eventData = [
    {
      id: 1,
      date: "14th Sept, 2024",
      title: "Jame & Sarah Wedding",
      type: "Wedding",
      time: "8:00 AM",
      location: "Ikoyi Private Suite, Lagos",
      attendees: 10,
      image: "/images/eventImage.jpg",
    },
    {
      id: 2,
      date: "14th Sept, 2024",
      title: "Adeyanju Family Naming ceremony",
      type: "Naming Ceremony",
      time: "8:00 AM",
      location: "Ikoyi Private Suite, Lagos",
      attendees: 10,
      image: "/images/eventImage.jpg",
    },
    {
      id: 3,
      date: "14th Sept, 2024",
      title: "Okene Royal Family Burial Program",
      type: "Burial",
      time: "8:00 AM",
      location: "Ikoyi Private Suite, Lagos",
      attendees: 10,
      image: "/images/eventImage.jpg",
    },
    {
      id: 4,
      date: "14th Sept, 2024",
      title: "Adeyanju Family Naming ceremony",
      type: "Naming Ceremony",
      time: "8:00 AM",
      location: "Ikoyi Private Suite, Lagos",
      attendees: 10,
      image: "/images/eventImage.jpg",
    },
    {
      id: 5,
      date: "14th Sept, 2024",
      title: "Okene Royal Family Burial Program",
      type: "Burial",
      time: "8:00 AM",
      location: "Ikoyi Private Suite, Lagos",
      attendees: 10,
      image: "/images/eventImage.jpg",
    },
  ];

  const eventTabs = [
    { id: "upcoming", label: "Upcoming Event" },
    { id: "history", label: "History" },
  ];

  const guestFilters = [
    { id: "all", label: "All", active: true },
    { id: "regular", label: "Regular", active: false },
    { id: "rsvp", label: "RSVP", active: false },
  ];

  const monthFilters = [
    { id: "all", label: "All", active: true },
    { id: "lastMonth", label: "Last Month", active: false },
    { id: "thisMonth", label: "This Month", active: false },
  ];

  return (
    <div className="guesttab-eventManagement">
      <Header />

      <div className="guesttab-eventManagement-header">
        <EventHeader
          title="Guest"
          showBackButton={false}
          showStatus={false}
          showDate={false}
        />
      </div>

      <div className="guesttab-stats-grid">
        <>
          <StatCards
            displayCards={{
              totalEvent: true,
              eventAttire: true,
              ticketAmount: true,
              cashGift: true,
              totalGuest: true,
              overallAmount: false,
              refundRequest: false,
            }}
          />
        </>
      </div>

      <div className="guesttab-events-section">
        <TabSelector
          tabs={[
            { id: "upcoming", label: "Upcoming Event" },
            { id: "active", label: "Active" },
            { id: "history", label: "History" },
          ]}
          onTabChange={handleTabChange}
          withSearch={true}
          badgeCount={5}
        />

        <div className="guesttab-events-list">
          {eventData.map((event) => (
            <div
              key={event.id}
              onClick={() => handleEventClick(event.id)}
              className="guesttab-event-card-wrapper"
            >
              <EventCard
                date={event.date}
                title={event.title}
                type={event.type}
                time={event.time}
                location={event.location}
                attendees={event.attendees}
                image={event.image}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EventManagement;
